import React from 'react'
import { string } from 'prop-types'
import classNames from 'classnames'
import { useDarkContext } from '@/component/Context/DarkContext'

import Type from '@/component/Primitive/Type'

import styles from './ListItem.module.scss'

function ListItem({ title, value }) {
  const isDark = useDarkContext()
  return (
    <li className={classNames(styles.ListItem, isDark && styles.isDark)}>
      <Type className={styles.Title} as="h4" size="base">
        {title}
      </Type>{' '}
      <Type as="h4" size="base">
        {value}
      </Type>
    </li>
  )
}

ListItem.propTypes = {
  title: string.isRequired,
  value: string
}

export default ListItem
